import React from 'react';
import Slider from 'react-slick';
import { useGetBlogPostsQuery } from '../../../redux/slices/blogPostSlice';

import BlogPostTease from './BlogPostTease';

import styles from '../FeaturedTrucks.module.postcss';
import ErrorBoundary from '../../shared/ErrorBoundary';

const defaultSettings = {
  slidesToShow: 4,
  slidesToScroll: 2,
  infinite: false,
  lazyLoad: 'anticipated',
  waitForAnimate: false,
  useCSS: true,
  useTransform: true,
  responsive: [
    {
      breakpoint: 1350,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 1250,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 732,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};

function FeaturedBlogPostsScroll({ title }) {
  const { data = {} } = useGetBlogPostsQuery({ published: true });
  const blogPosts = data.blog_posts || [];

  if (!blogPosts || blogPosts.length < 1) {
    return null;
  }

  const slides = blogPosts.map((blogPost) => {
    return (
      <div key={'vendors-' + blogPost.id}>
        <BlogPostTease blogPost={blogPost} />
      </div>
    );
  });

  return (
    <div>
      <h2>{ title || 'Recent posts'}</h2>
      <Slider className={styles.FeaturedTrucks} {...defaultSettings}>
        {slides}
      </Slider>
    </div>
  );
}

// react-slick / third-party render paths can throw; a crash drops this carousel and keeps the rest of the page.
// Wrapped here rather than at every call site.
function FeaturedBlogPostsScrollBoundary(props) {
  return (
    <ErrorBoundary name='FeaturedBlogPostsScroll'>
      <FeaturedBlogPostsScroll {...props} />
    </ErrorBoundary>
  );
}

export default FeaturedBlogPostsScrollBoundary;
